import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, ShieldCheck } from "lucide-react";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try { await api.post("/newsletter", { email }); toast.success("Subscribed! Watch your inbox for deals."); setEmail(""); }
    catch { toast.error("Something went wrong."); }
  };
  return (
    <footer className="bg-[#0B3C5D] text-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <img src="/logo-footer.png" alt="Elia Travel & Tours" className="h-12 w-auto object-contain" />
          </div>
          <p className="text-sm text-slate-300 leading-relaxed">
            Your trusted travel partner for flights, hotels, holidays, car hire and Umrah &amp; Hajj packages worldwide.
          </p>
          <div className="flex gap-3 mt-5 items-center text-xs text-slate-300">
            <ShieldCheck className="w-5 h-5 text-[#FF6B35]" /> 100% Secure &amp; Encrypted Payments
          </div>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/flights" className="hover:text-[#FF6B35]">Flights</Link></li>
            <li><Link to="/hotels" className="hover:text-[#FF6B35]">Hotels</Link></li>
            <li><Link to="/holidays" className="hover:text-[#FF6B35]">Holidays</Link></li>
            <li><Link to="/car-hire" className="hover:text-[#FF6B35]">Car Hire</Link></li>
            <li><Link to="/umrah" className="hover:text-[#FF6B35]">Umrah &amp; Hajj</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#FF6B35]" /> Unit 6a, 802-804 Stratford Road, Sparkhill, Birmingham, B11 4BS</li>
            <li className="flex gap-2"><Phone className="w-4 h-4 text-[#FF6B35]" /> 020 4615 3141</li>
            <li className="flex gap-2"><Mail className="w-4 h-4 text-[#FF6B35]" /> info@eliatravelandtours.co.uk</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-4">Newsletter</h4>
          <p className="text-sm text-slate-300 mb-3">Get exclusive deals straight to your inbox.</p>
          <form onSubmit={subscribe} className="flex gap-2">
            <input data-testid="newsletter-email" value={email} onChange={(e) => setEmail(e.target.value)}
              type="email" required placeholder="Your email"
              className="flex-1 rounded-full px-4 py-2 text-sm text-slate-900 outline-none" />
            <button data-testid="newsletter-submit" className="rounded-full bg-[#FF6B35] hover:bg-[#e85a26] px-4 py-2 text-sm font-semibold text-white">Join</button>
          </form>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 text-xs text-slate-400 space-y-2">
          <p className="font-medium text-slate-300">
            ELIA TRAVEL AND TOURS LTD, COMPANY NUMBER 16408376, Registered office: Unit 6a, 802-804 Stratford Road, Sparkhill, Birmingham, England, B11 4BS
          </p>
          <p>© {new Date().getFullYear()} Elia Travel and Tours Ltd. All rights reserved.</p>
          <p><Link to="/admin/login" className="hover:text-[#FF6B35]">Staff Login</Link></p>
        </div>
      </div>
    </footer>
  );
};
